import { Routes, Route, Outlet, Navigate } from "react-router";
import { MainLayout } from "./layouts/MainLayout";
import { REFERENCIAS_DE_MERCADO } from "./lib/modulos";
import { Dashboard } from "./pages/Dashboard";
import { Novedades } from "./pages/Novedades";
import { Feedback } from "./pages/Feedback";
import { Usuarios } from "./pages/Usuarios";
import { UsuarioNuevo } from "./pages/UsuarioNuevo";
import { UsuarioEditar } from "./pages/UsuarioEditar";
import { Perfiles } from "./pages/Perfiles";
import { PerfilNuevo } from "./pages/PerfilNuevo";
import { PerfilEditar } from "./pages/PerfilEditar";
import { CrearInforme } from "./pages/CrearInforme";
import { ComparacionConMercado } from "@/pages/ComparacionConMercado";
import { ReferenciasDelInforme } from "@/pages/ReferenciasDelInforme";
import { ElegirInformeParaReferencias } from "./pages/ElegirInformeParaReferencias";
import { InformesEnProceso } from "./pages/InformesEnProceso";
import { InformeEditar } from "./pages/InformeEditar";
import { GeneracionDelInforme } from "./pages/GeneracionDelInforme";
import { RevisionesPendientes } from "./pages/RevisionesPendientes";
import { VisadoDeCotizacion } from "./pages/VisadoDeCotizacion";
import { CotizacionEnviada } from "./pages/CotizacionEnviada";
import { CotizarInforme } from "./pages/CotizarInforme";
import { Contenidos } from "./pages/Contenidos";
import { FormatoDeSalida } from "./pages/FormatoDeSalida";
import { FormatosDeSalida } from "./pages/FormatosDeSalida";
import { MaestroDeItems } from "./pages/MaestroDeItems";
import { PlantillaEditar } from "./pages/PlantillaEditar";
import { Contextos } from "./pages/Contextos";
import { RevisionInformes } from "./pages/RevisionInformes";
import { Configuracion } from "./pages/Configuracion";
import { DesignSystem } from "./pages/DesignSystem";
import { MantenedorDeClasesDeSuelo } from "@/pages/MantenedorDeClasesDeSuelo";
import { MantenedorDeHomologacion } from "@/pages/MantenedorDeHomologacion";
import { MantenedorDeCotizacion } from "./pages/MantenedorDeCotizacion";
import { DatosEmpresa } from "./pages/DatosEmpresa";
import { MantenedorDeIa } from "./pages/MantenedorDeIa";
import { ConsumoDeIa } from "./pages/ConsumoDeIa";
import { LaboratorioDeIa } from "./pages/LaboratorioDeIa";
import { Login } from "./pages/auth/Login";
import { RecuperarContrasena } from "./pages/auth/RecuperarContrasena";
import { ResetPassword } from "./pages/auth/ResetPassword";
import { AceptarCotizacion } from "./pages/AceptarCotizacion";
import { PortalDelCliente } from "./pages/PortalDelCliente";
import { VerificarCotizacion } from "./pages/VerificarCotizacion";
import { ActivarCuenta } from "./pages/auth/ActivarCuenta";
import { ProtectedRoute } from "./components/auth/ProtectedRoute";
import { RequiereRol } from "./components/RequiereRol";
import { Toaster } from "./components/ui/sonner";

function NotFound() {
  return (
    <div className="flex items-center justify-center h-full">
      <div className="text-center">
        <h1 className="text-2xl font-bold">404</h1>
        <p className="text-muted-foreground">Página no encontrada</p>
      </div>
    </div>
  );
}

function App() {
  return (
    <>
      <Routes>
        {/* Autenticación (sin layout) */}
        <Route path="/login" element={<Login />} />
        <Route path="/recuperar-contrasena" element={<RecuperarContrasena />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="/activar-cuenta" element={<ActivarCuenta />} />

        {/* Aceptación de la cotización por el CLIENTE (entrega D). Pública y
            sin layout de app: del otro lado hay alguien que no tiene cuenta en
            Consultek, así que no puede ver menú, barra ni nada que suponga una
            sesión. El token de la URL es su única credencial. */}
        <Route path="/aceptar-cotizacion/:token" element={<AceptarCotizacion />} />

        {/* Verificación del sello impreso en el documento de cotización.
            También pública y sin layout, y por un motivo más amplio que la de
            arriba: quien escanea el QR puede no ser ni siquiera el cliente
            —un banco, un perito de la contraparte, un tribunal—. Es de SOLO
            LECTURA: no acepta nada, no cambia nada y su código no se gasta. */}
        <Route path="/verificar-cotizacion/:token" element={<VerificarCotizacion />} />

        {/* Portal del CLIENTE: deja los antecedentes y carga sus datos de
            facturación. También pública y sin layout de app, por lo mismo que
            las dos de arriba.

            DOS RUTAS PARA UNA PANTALLA, y eso es lo importante acá: el correo
            de aceptación trae dos botones —uno por sección— porque adentro de
            la empresa del cliente las hacen personas distintas. Los papeles del
            predio los junta quien conoce la propiedad; el RUT y el giro los
            tiene contabilidad. Cada botón tiene que caer donde promete, así que
            la sección va en la URL y no en un `useState`. De paso sobrevive a
            recargar y a reenviar el enlace, que es justo lo que va a pasar. */}
        <Route path="/portal/:token" element={<PortalDelCliente seccion="documentos" />} />
        <Route
          path="/portal/:token/facturacion"
          element={<PortalDelCliente seccion="facturacion" />}
        />

        {/* Rutas internas (protegidas, con layout) */}
        <Route element={<ProtectedRoute />}>
          <Route element={<MainLayout><Outlet /></MainLayout>}>
            {/* La portada de accesos se eliminó: era una escala de más entre
                el login y el trabajo. "/" ya no es una pantalla — es la puerta
                que lleva a la cola de informes, que ahora es la primera.

                Se conserva como REDIRECCIÓN en vez de borrarse porque "/"
                sigue llegando desde afuera: es el destino por defecto tras el
                login, el enlace del logo y todo marcador que alguien haya
                guardado. Sin esta fila, los tres caían en el 404.

                El Dashboard anterior sigue vivo en /dashboard-legacy pero SIN
                acceso desde el menú: todavía no está aprobado, así que la ruta
                se conserva y la fila se sacó (ver `lib/menu.ts`). Borrar la
                ruta obligaría a rehacerla. */}
            <Route path="/" element={<Navigate to="/informes" replace />} />
            <Route path="/dashboard-legacy" element={<Dashboard />} />
            <Route path="/novedades" element={<Novedades />} />
            <Route path="/feedback" element={<Feedback />} />
            {/* Módulo E. SIN `RequiereRol`: el spec §8 declara la creación de
                informes visible para Usuario Normal, Usuario Revisor y Super
                Admin — es el trabajo del día a día, no administración, y por
                eso tampoco cuelga de /admin. */}
            <Route path="/informes" element={<InformesEnProceso />} />
            {/* Referencias de mercado. NO cuelga de `/informes` a propósito:
                es una acción sobre un informe que se elige adentro, no una
                vista de un informe ya identificado por la url.

                LAS RUTAS TAMBIÉN SE APAGAN, no solo el botón (ver
                `lib/modulos.ts`). Esconder el acceso y dejar las pantallas
                vivas es esconder una puerta, no cerrarla: el módulo consume una
                segunda base de datos que en el servidor todavía no existe, así
                que quien llegara por la url —un marcador, un enlace pegado—
                vería un error del sistema en vez de un 404. Un 404 dice la
                verdad: acá no hay nada todavía. */}
            {REFERENCIAS_DE_MERCADO && (
              <>
                <Route path="/referencias" element={<ElegirInformeParaReferencias />} />
                <Route
                  path="/referencias/:informeId"
                  element={<ComparacionConMercado />}
                />
                <Route
                  path="/referencias/:informeId/enlazadas"
                  element={<ReferenciasDelInforme />}
                />
              </>
            )}
            <Route path="/informes/nuevo" element={<CrearInforme />} />
            {/* Va DESPUÉS de /informes/nuevo: al revés, "nuevo" entraría por
                el parámetro `:id` y la pantalla pediría el informe NaN. */}
            <Route path="/informes/:id" element={<InformeEditar />} />
            <Route path="/informes/:id/cotizacion" element={<CotizarInforme />} />
            {/* La confirmación del correo generado. Tiene URL propia porque
                era estado local del formulario: cualquier navegación la
                borraba, y volver desde el documento caía en el formulario. */}
            <Route path="/informes/:id/cotizacion/enviada" element={<CotizacionEnviada />} />
            {/* La generación del informe con IA (fase 1: análisis y dudas). Es
                una hermana estática, no una pestaña: gana al `:pestana` de más
                abajo por el ranking del router, y `pageMeta.ts` la declara
                antes por el mismo motivo que la cotización. */}
            <Route path="/informes/:id/generacion" element={<GeneracionDelInforme />} />
            {/* La PESTAÑA del editor viaja en la url. Antes era un `useState`
                de la pantalla, y eso costaba tres cosas: recargar devolvía a
                "Antecedentes generales" con toda la carga de trabajo de la
                pestaña perdida, no se podían abrir dos pestañas del mismo
                informe en dos ventanas, y no había enlace que compartir. Es la
                misma corrección que ya recibió `/informes/:id/cotizacion/enviada`
                acá arriba.

                `/informes/:id` a secas sigue valiendo y abre la primera
                pestaña: es la url que emiten `urlDeLaEdicion`, el banner de
                cotización y las cuatro pantallas desde las que se entra a
                editar, así que redirigir haría rebotar cada entrada.

                VA DESPUÉS DE LAS HERMANAS ESTÁTICAS. React Router rankea el
                segmento fijo por encima del dinámico, así que
                `/informes/7/cotizacion` gana igual sin importar el orden — pero
                `pageMeta.ts` SÍ recorre sus patrones en orden, y tener las dos
                declaraciones alineadas es lo que evita que el árbol de rutas y
                el header discrepen sobre qué pantalla es esa url.

                Lo que el ranking no puede cubrir es que una pestaña se LLAME
                como una hermana: ahí el síntoma sería una pantalla que abre
                otra, sin error y sin aviso. Lo custodia `App.test.tsx`. */}
            <Route path="/informes/:id/:pestana" element={<InformeEditar />} />
            {/* Módulo G. SIN `RequiereRol` y fuera de /admin: RF-G1 la declara
                del perfil Revisor, pero la API tampoco la gatea por perfil
                (`RevisionPendienteController`, a propósito). Gatearla acá sola
                dejaría al webapp negando lo que el servidor concede. */}
            <Route path="/revisiones" element={<RevisionesPendientes />} />
            {/* El detalle de revisión (RF-G2/G3). Cuelga de la bandeja y NO de
                `/informes/:id/...`: es el puesto de trabajo del revisor, con
                sus acciones y su salida hacia la cola. La vista previa del
                documento del cliente sigue viviendo en la rama de `/informes`,
                que es el flujo del ejecutivo. */}
            <Route path="/revisiones/:id" element={<VisadoDeCotizacion />} />
            {/* /admin/* es del Super Admin: RequiereRol muestra un estado de
                "sin permiso" si el perfil activo no corresponde. `App.test.tsx`
                monta este árbol y verifica que TODA ruta /admin declarada acá
                esté envuelta — el olvido no se detecta leyendo. */}
            <Route path="/admin/usuarios" element={<RequiereRol><Usuarios /></RequiereRol>} />
            <Route
              path="/admin/usuarios/nuevo"
              element={<RequiereRol><UsuarioNuevo /></RequiereRol>}
            />
            <Route
              path="/admin/usuarios/:id/editar"
              element={<RequiereRol><UsuarioEditar /></RequiereRol>}
            />
            {/* Perfiles: submódulo del Mantenedor de usuarios (10/11/12 SA). */}
            <Route path="/admin/perfiles" element={<RequiereRol><Perfiles /></RequiereRol>} />
            <Route
              path="/admin/perfiles/nuevo"
              element={<RequiereRol><PerfilNuevo /></RequiereRol>}
            />
            <Route
              path="/admin/perfiles/:id/editar"
              element={<RequiereRol><PerfilEditar /></RequiereRol>}
            />
            {/* Plantillas de informe y maestro de ítems: tres pantallas bajo la
                misma entrada del menú ("Contenidos"). */}
            <Route path="/admin/contenidos" element={<RequiereRol><Contenidos /></RequiereRol>} />
            <Route
              path="/admin/contenidos/maestro"
              element={<RequiereRol><MaestroDeItems /></RequiereRol>}
            />
            <Route
              path="/admin/contenidos/formatos"
              element={<RequiereRol><FormatosDeSalida /></RequiereRol>}
            />
            <Route
              path="/admin/contenidos/formatos/:id"
              element={<RequiereRol><FormatoDeSalida /></RequiereRol>}
            />
            <Route
              path="/admin/contenidos/plantillas/:id"
              element={<RequiereRol><PlantillaEditar /></RequiereRol>}
            />
            <Route path="/admin/contextos" element={<RequiereRol><Contextos /></RequiereRol>} />
            <Route
              path="/admin/revision-informes"
              element={<RequiereRol><RevisionInformes /></RequiereRol>}
            />
            {/* Mantenedor de IA: acá se ajusta el prompt y el modelo de cada
                función sin desplegar. Bajo /admin porque el prompt decide cómo
                la IA escribe en documentos que terminan en juicios. */}
            <Route path="/admin/ia" element={<RequiereRol><MantenedorDeIa /></RequiereRol>} />
            {/* Cuánto gasta el sistema en IA y en qué
                (`odd/tasks/consumo-de-ia.md`): KPIs, costo diario, desglose
                por función y por modelo, el log de peticiones y el catálogo
                de precios. Cuelga de la misma sección que las funciones, no
                de una propia — el Mantenedor de IA pasó a agrupar las dos en
                el menú. */}
            {/* Laboratorio de IA: prompts con borrador, casos congelados,
                experimentos y el registro de corridas. Super Admin, como el
                resto del mantenedor: publicar un prompt cambia lo que la IA
                escribe en los informes. */}
            <Route
              path="/admin/ia/laboratorio"
              element={<RequiereRol><LaboratorioDeIa /></RequiereRol>}
            />
            <Route
              path="/admin/ia/consumo"
              element={<RequiereRol><ConsumoDeIa /></RequiereRol>}
            />
            {/* Mantenedor del documento de cotización: los párrafos fijos y el
                catálogo con que se arman Metodología y Documentación. Bajo
                /admin porque cambiar uno cambia lo que dicen todas las
                cotizaciones que se emitan después. */}
            <Route
              path="/admin/cotizacion"
              element={<RequiereRol><MantenedorDeCotizacion /></RequiereRol>}
            />
            {/* Tablas de homologación: la escala con que se corrige cada
                comparable contra el predio tasado. Bajo /admin porque estos
                porcentajes deciden el valor que termina en un informe
                pericial, en todos los que se hagan después. */}
            <Route
              path="/admin/homologacion"
              element={<RequiereRol><MantenedorDeHomologacion /></RequiereRol>}
            />
            {/* Catálogo de clases de uso de suelo: con qué se describen los
                suelos de un predio. Bajo /admin porque lo que se agregue acá
                es lo que todos los tasadores podrán elegir, y el código
                elegido se imprime en el cuadro de un informe pericial. */}
            <Route
              path="/admin/clases-de-suelo"
              element={<RequiereRol><MantenedorDeClasesDeSuelo /></RequiereRol>}
            />
            {/* Datos de la empresa: el bloque de contacto que el documento
                de cotización imprime en el pie de cada página, en la portada
                y en la contraportada. Bajo /admin porque cambiarlo cambia
                todas las cotizaciones que se emitan después. */}
            <Route
              path="/admin/empresa"
              element={<RequiereRol><DatosEmpresa /></RequiereRol>}
            />
            <Route
              path="/admin/configuracion"
              element={<RequiereRol><Configuracion /></RequiereRol>}
            />
            <Route path="/design-system" element={<DesignSystem />} />
            <Route path="*" element={<NotFound />} />
          </Route>
        </Route>
      </Routes>
      <Toaster />
    </>
  );
}

export default App;
